<template>
    <div>
      <x-markdown :md.sync='md' style="min-height: 900px;"/>
    </div>
</template>

<script>
import markdownComponent from '@/views/components/markdown'

export default {
  components: {
    'x-markdown': markdownComponent
  },
  data () {
    return {
      md: 'empty'
    }
  },
  mounted () {
    let route = this.$route.path
    const trimSlashes = str => str.replace(/^\/+|\/+$/g, '')
    this.md = trimSlashes(route)
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/deletion.vue